import { useDispatch, useSelector } from "react-redux";
import { resetCategory, selectSelectedCategory, selectSelectedCategoryUpdateId, selectSelectedTabs, selectTypeOfModal, setCategory, setManageModal, setSelectedCategory } from "../../features/it-user-forms/user-forms-slice";
import { useMutation } from "../services/mutations/use-mutation";
import { CategoryTab, CategoryType } from "../../types/type";
import { CategoryTable } from "../../api/it/account-category/account-category-api-state";
import { useToastify } from "../../library/toastify/toast-provider";

export const useCategoryActions = () => {

    const { showToastNotify } = useToastify();
    const dispatch = useDispatch();
    const category = useSelector(selectSelectedCategory);
    const typeOfAction = useSelector(selectTypeOfModal);
    const categoryId = useSelector(selectSelectedCategoryUpdateId);
    const isUpdate = typeOfAction === 'update'
    const isNew = typeOfAction === 'new'
    const typeOfCategory = useSelector(selectSelectedTabs);
    const title = typeOfCategory.slice(0, -1).toUpperCase() as CategoryType
    const { createCategory, updateCategory } = useMutation()

    const handleShowModal = (value: CategoryTab) => {
        dispatch(setSelectedCategory(value))
        dispatch(setManageModal({ type: 'isShow', value: true }))
        dispatch(setManageModal({ type: 'modalType', value: 'new' }))
    }

    const handleSelect = (value: CategoryTable) => {
        dispatch(setSelectedCategory(value.type))
        dispatch(setCategory({ type: 'name', value: value.name }))
        dispatch(setCategory({ type: 'code', value: value.code }))
        dispatch(setCategory({ type: 'is_active', value: value.status }))
        dispatch(setManageModal({ type: 'isShow', value: true }))
        dispatch(setManageModal({ type: 'modalType', value: 'update' }))
        dispatch(setManageModal({ type: 'id', value: value.id }))
    }

    const handleClose = () => {
        dispatch(setManageModal({ type: 'isShow', value: false }))
        dispatch(setManageModal({ type: 'id', value: null }))
        dispatch(setManageModal({ type: 'modalType', value: null }))
        dispatch(resetCategory())
    }

    const handleSaveCategory = async () => {
        try {
            if (!category.name.trim()) {
                return showToastNotify("Category name is required.", "warning");
            }

            if (!category.code.trim()) {
                return showToastNotify("Category code is required.", "warning");
            }
            if(isUpdate) {
                if(!categoryId) return showToastNotify('Missing parameter.', 'warning')
                const updateBody = {
                    name: category.name,
                    code: category.code,
                    is_active: category.is_active,
                }
                await updateCategory({ categoryId, body: updateBody }).unwrap()
                showToastNotify("Category updated successfully.", "success");
            }
            if(isNew) {
                const body = {
                    name: category.name,
                    code: category.code,
                }
                await createCategory({ category: title, body }).unwrap()
                showToastNotify("Category created successfully.", "success");
            }

            dispatch(setManageModal({ type: 'isShow', value: false }))
            dispatch(setManageModal({ type: 'id', value: null }))
            dispatch(setManageModal({ type: 'modalType', value: null }))
            dispatch(resetCategory())
        } catch (error: any) {
            const errorMsg = error?.data?.message ?? "Something went wrong. Please try again"
            showToastNotify(errorMsg, 'error')
        }
    }

    return {
        handleSaveCategory,

        handleShowModal,
        handleSelect,
        handleClose,
    }
}